import React from "react";
import { Box, Stack, Text } from "@origin-digital/ods-core";
import SidebarItem from "src/components/Form/SideBar/SidebarItem";
import { formSectionService } from "src/services/formSectionService";
import { GasOptionEnum } from "src/components/Form/types";
import { BoxedSpinner } from "src/components/FeedContainer/BoxedSpinner";
import { SidebarSectionProps } from "../types";
import { useSidebarSection } from "./useSidebarSection";

export const SidebarSection = ({
  premiseBlockRef,
  accountBlockRef,
  electricityBlockRef,
  gasLineBlockRef,
  gasBothBlockRef,
  gasMeterBlockRef,
  closeTransferBlockRef,
}: SidebarSectionProps) => {
  const {
    isClaim,
    visibleBlocks,
    address,
    state,
    postcode,
    requestDetailsLoaded,
    sidebarStatus,
    electricityIds,
    gasLineIds,
    gasMeterIds,
    gasBothIds,
    selectSidebarItem,
  } = useSidebarSection();
  if (isClaim) {
    return <></>;
  } else if (requestDetailsLoaded) {
    return (
      <>
        {address ? (
          <Box
            paddingTop="medium"
            paddingBottom={{
              lg: "small",
              xs: "xsmall",
            }}
            paddingX="large"
          >
            <Stack space="xsmall">
              <Text>{address}</Text>
            </Stack>
          </Box>
        ) : null}
        <Stack space="none">
          {/* Item 1 */}
          <SidebarItem
            name="Premises"
            id={"premiseBlock"}
            icon={sidebarStatus["premiseBlock"]}
            onSelect={() => selectSidebarItem(premiseBlockRef)}
          />
          {/* End item 1  */}
          {/* Item 2 */}
          {visibleBlocks.accountBlock && (
            <SidebarItem
              name="Account"
              id={"accountBlock"}
              icon={sidebarStatus["accountBlock"]}
              onSelect={() => selectSidebarItem(accountBlockRef)}
            />
          )}
          {/* End item 2  */}
          {/* Item 3 */}
          {visibleBlocks.electricityBlock && (
            <SidebarItem
              name="Electricity"
              id={"electricityBlock"}
              icon={sidebarStatus["electricityBlock"]}
              onSelect={() => selectSidebarItem(electricityBlockRef)}
              journeyId={electricityIds.journeyId}
              requestId={electricityIds.requestId}
              distributorApplicationId={electricityIds.distributorApplicationId}
            />
          )}
          {/* End item 3  */}
          {/* Item 4 */}
          {visibleBlocks.gasLineBlock && (
            <SidebarItem
              name={formSectionService.getGasTitle(
                state,
                GasOptionEnum.GAS_LINE,
                postcode
              )}
              id={"gasLineBlock"}
              icon={sidebarStatus["gasLineBlock"]}
              onSelect={() => selectSidebarItem(gasLineBlockRef)}
              journeyId={gasLineIds.journeyId}
              requestId={gasLineIds.requestId}
            />
          )}
          {visibleBlocks.gasMeterBlock && (
            <SidebarItem
              name={formSectionService.getGasTitle(
                state,
                GasOptionEnum.GAS_METER,
                postcode
              )}
              id={"gasMeterBlock"}
              icon={sidebarStatus["gasMeterBlock"]}
              onSelect={() => selectSidebarItem(gasMeterBlockRef)}
              journeyId={gasMeterIds.journeyId}
              requestId={gasMeterIds.requestId}
            />
          )}
          {visibleBlocks.gasBothBlock && (
            <SidebarItem
              name={formSectionService.getGasTitle(
                state,
                GasOptionEnum.BOTH,
                postcode
              )}
              id={"gasBothBlock"}
              icon={sidebarStatus["gasBothBlock"]}
              onSelect={() => selectSidebarItem(gasBothBlockRef)}
              journeyId={gasBothIds.journeyId}
              requestId={gasBothIds.requestId}
            />
          )}
          {/* End item 4 */}
          {/* Item 5 */}
          {visibleBlocks.closeTransferBlock && (
            <SidebarItem
              name="Close/Transfer"
              id={"closeTransferBlock"}
              onSelect={() => selectSidebarItem(closeTransferBlockRef)}
            />
          )}
          {/* End item 5 */}
        </Stack>
      </>
    );
  } else {
    return <BoxedSpinner />;
  }
};
